const ArrayCleaner = (array) => {
  var newArray = []
  for (var i = 0; i < array.length; i++) {
    if (array[i]) {
      newArray.push(array[i])
    }
  }
  return newArray
}
export default ArrayCleaner



// WEBPACK FOOTER //
// ./src/Utils/ArrayCleaner.js